import { createContext, useContext } from 'react'

import type { TAttentionStatusSeverity } from 'partner360/entities/attentionStatuses'

/* `null` outside a status' detail. */
const AttentionDetailSeverityContext = createContext<TAttentionStatusSeverity | null>(null)

/** Hands a status section the level of the status it is drawn for, so its calls wear its colour. */
export const AttentionDetailSeverityProvider = AttentionDetailSeverityContext.Provider

/** The level of the opened status; `null` where the section stands outside a detail. */
export const useAttentionDetailSeverity = () => useContext(AttentionDetailSeverityContext)
